module.exports = __webpack_public_path__ + "static/img/多工具调用@2x.505bc024.png";